<template>
  <AppLazySelect
    ref="lazySelect"
    v-model="value"
    resource="member"
    :label="withLabel ? 'Member' : ''"
    :filters="filters"
    :fetcher="fetcher"
    data-testid="activities-member-select"
    teleport-to-body
  >
    <template #single-result-leading="{ value }">
      <AppAvatar
        v-if="value.avatar"
        :avatar="value.avatar"
        size="speck"
      />
    </template>

    <template #item-leading="{ item: user }">
      <AppAvatar
        v-if="user.avatar"
        :avatar="user.avatar"
        size="speck"
      />
    </template>

    <template #item-trailing="{ item: user }">
      <span v-if="shouldDisplayActivity(user)">
        {{ formatLastActivity(user.last_activity) }}
      </span>
    </template>
  </AppLazySelect>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { ActivitiesResource } from '~/resources';
import { datetimeWithZone } from '~/utils/time_utils';

import { INSIGHTS } from '~/app_constants';

export default {
  name: 'ActivitiesLazyMembersSelect',
  props: {
    withLabel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filters() {
      return [
        { id: 'tracked', label: 'Tracked time', value: true },
        { id: 'tracked', label: 'No time tracked', value: false },
      ];
    },
    ...mapState({
      user: (state) => state.user,
      loading: (state) => state.loading,
      date: (state) => state?.activities_query?.date,
      organizationId: (state) => state.organization?.id,
    }),
    ...mapGetters(['currentZone']),
    value: {
      get() {
        return this.user ?? null;
      },
      async set(user = null) {
        const widgetKeys = [INSIGHTS.api.highlights.workTimeClassification, INSIGHTS.api.focusTime];

        // Mark widgets as loading
        widgetKeys.forEach((key) => {
          this.$store.commit('SET_WIDGET_LOADING', { key, status: true });
        });

        const userId = user?.id ?? null;
        const hasValidActivity = user?.last_activity && this.shouldDisplayActivity(user);
        const date = hasValidActivity
          ? datetimeWithZone(moment(user.last_activity), this.currentZone.name).format('YYYY-MM-DD')
          : null;
        const queryParams = { user_id: userId };
        const insightsParams = { user_id: userId };
        const filterParams = { user: userId };

        if (date) {
          queryParams.date = date;
          insightsParams.date = date;
          filterParams.date = date;
        }

        // Widgets need setQuery to go first
        this.setQuery(queryParams);
        this.setInsightsFilter(insightsParams);
        this.setFilter(filterParams);
      },
    },
  },
  methods: {
    ...mapActions(['setInsightsFilter', 'setFilter', 'setQuery']),
    shouldDisplayActivity(user) {
      if (user.hide_last_activity) {
        return false;
      }

      return !user?.last_activity || !moment(user.last_activity).isSame(moment(this.date), 'day');
    },
    formatLastActivity(date) {
      return date ? datetimeWithZone(moment(date), this.currentZone.name).format('MMM DD') : 'None';
    },
    fetcher(payload) {
      const finalPayload = {
        ...payload,
        date: this.date,
        with_activity: true,
      };

      return ActivitiesResource.members({ organization_id: this.organizationId }, finalPayload, {
        abortReload: true,
      });
    },
  },
};
</script>
